import Vue from 'vue';

const store = Vue.observable({
  cartOpen: false,
  customerCountry: 'NZ',
  collectionActiveFilter: false,
});

const actions = {
  toggleCart() {
    store.cartOpen = !store.cartOpen;
  },
  updateCollectionActiveFilter(value) {
    if (value === store.collectionActiveFilter) {
      store.collectionActiveFilter = false;
    } else {
      store.collectionActiveFilter = value;
    }
  },
};

Vue.prototype.$store = store;
Vue.prototype.$actions = actions;
